module.exports = __webpack_public_path__ + "img/icon-ecosystem-blue.560e48c6.svg";